import axios from "./config";
import { AxiosResponse } from "axios";
import {
  DeliveriesApiResponse,
  RevenueApiResponse,
  SignUpsApiResponse,
} from "app/types/lightfieldsAnalytics";

const encodeDateParam = (value: string) => encodeURIComponent(value);

export const getSignUpsApi = (
  storeId: number,
  fromDate: string,
  toDate: string,
): Promise<AxiosResponse<SignUpsApiResponse>> =>
  axios.get<SignUpsApiResponse>(
    `/stores/${storeId}/sign-ups?FromDate=${encodeDateParam(fromDate)}&ToDate=${encodeDateParam(toDate)}`,
  );

export const getDeliveriesApi = (
  storeId: number,
  fromDate: string,
  toDate: string,
): Promise<AxiosResponse<DeliveriesApiResponse>> =>
  axios.get<DeliveriesApiResponse>(
    `/stores/${storeId}/deliveries?FromDate=${encodeDateParam(fromDate)}&ToDate=${encodeDateParam(toDate)}`,
  );

export const getRevenueApi = (
  storeId: number,
  startDate: string,
  endDate: string,
): Promise<AxiosResponse<RevenueApiResponse>> =>
  axios.get<RevenueApiResponse>(
    `/stores/${storeId}/revenue?startDate=${encodeDateParam(startDate)}&endDate=${encodeDateParam(endDate)}`,
  );
